import Block from '@/components/Cart/modal/Block/Block';
import COLORS from '@/constants/colors';
import { Typography } from '@mui/material';
import { useBalanceViewController } from './BalanceViewController';

export function Balance() {
  const { uiState } = useBalanceViewController();

  return (
    <Block sx={{ display: 'inline-block', ml: { xs: '16px', md: 0 } }}>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 500,
          fontSize: '14px',
          color: COLORS.gray_600,
        }}
      >
        Balance Magicpay
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 600,
          fontSize: '24px',
          color: COLORS.mercanto_blue,
        }}
      >
        {uiState.balanceAmount}
      </Typography>
    </Block>
  );
}
